module.exports = {"TXTWCL_Stake":{"id":"TXTWCL_Stake","defaultMessage":"Einsatz","track":"Stake"}}